import { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface BreadcrumbItem {
    title: string | ReactNode;
    path?: string;
}

interface PageTitleContextType {
    breadcrumbs: BreadcrumbItem[];
    setBreadcrumbs: (items: BreadcrumbItem[]) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(
    undefined
);

export const usePageTitle = () => {
    const context = useContext(PageTitleContext);
    if (!context) {
        throw new Error('usePageTitle must be used within a PageTitleProvider');
    }
    return context;
};

export const PageTitleProvider = ({ children }: { children: ReactNode }) => {
    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

    const value = useMemo(
        () => ({ breadcrumbs, setBreadcrumbs }),
        [breadcrumbs]
    );

    return (
        <PageTitleContext.Provider value={value}>
            {children}
        </PageTitleContext.Provider>
    );
};
